var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMover01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.996;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-mover-2",
    className: "st0",
    d: "M35.2,17.3l-4.7-4.7c-0.4-0.4-1.1-0.4-1.5,0c-0.2,0.2-0.3,0.5-0.3,0.7v1.4h-7.4V7.2h1.4 c0.6,0,1-0.5,1-1c0-0.3-0.1-0.5-0.3-0.7l-4.7-4.7c-0.4-0.4-1.1-0.4-1.5,0c0,0,0,0,0,0l-4.7,4.7c-0.4,0.4-0.4,1.1,0,1.5 c0.2,0.2,0.5,0.3,0.7,0.3h1.4v7.4H7.2v-1.4c0-0.6-0.5-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l-4.7,4.7c-0.4,0.4-0.4,1.1,0,1.5c0,0,0,0,0,0 l4.7,4.7c0.4,0.4,1.1,0.4,1.5,0c0.2-0.2,0.3-0.5,0.3-0.7v-1.4h7.4v7.4h-1.4c-0.6,0-1,0.5-1,1c0,0.3,0.1,0.5,0.3,0.7l4.7,4.7 c0.4,0.4,1.1,0.4,1.5,0c0,0,0,0,0,0l4.7-4.7c0.4-0.4,0.4-1.1,0-1.5c-0.2-0.2-0.5-0.3-0.7-0.3h-1.4v-7.4h7.4v1.4c0,0.6,0.5,1,1,1 c0.3,0,0.5-0.1,0.7-0.3l4.7-4.7C35.6,18.3,35.6,17.7,35.2,17.3C35.2,17.3,35.2,17.3,35.2,17.3L35.2,17.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMover01);
export default __webpack_public_path__ + "static/media/ico-mover-01.c989d11ae951a1fbc06b11e5ce5e07bd.svg";
export { ForwardRef as ReactComponent };